import React, { useMemo } from "react";
import {
  FaPhone,
  FaUsers,
  FaBullseye,
  FaFolderOpen,
  FaArrowUp,
  FaArrowDown,
} from "react-icons/fa";
import Tools from '../utils/Tools';

function MainTiles({
  callCount,
  agentCount,
  totalIntents,
  totalCategories,
  baselines,
  showTrends,
  dateRange,
}) {
  const percentageChangeContent = useMemo(() => {
    if (!showTrends) return null;

    const calculatePercentageChange = (current, baselines) => {
      // Todo: change
      if (dateRange === "thisWeek") {
        const change =
          ((current - baselines.numberOfCalls) / baselines.numberOfCalls) * 100;
        return change.toFixed(1);
      } else {
        if (
          !baselines ||
          !baselines.avgCallsPerDay ||
          baselines.avgCallsPerDay === 0
        )
          return null;
        const change =
          ((current - baselines.avgCallsPerDay) / baselines.avgCallsPerDay) *
          100;
        return change.toFixed(1);
      }
    };

    const percentageChange = calculatePercentageChange(callCount, baselines);

    if (percentageChange === null) return null;

    const isPositive = parseFloat(percentageChange) >= 0;
    const Icon = isPositive ? FaArrowUp : FaArrowDown;

    return (
      <span className="text-sm flex items-center">
        <Icon className="mr-1" />
        {Math.abs(percentageChange)}%
      </span>
    );
  }, [showTrends, callCount, baselines]);

  const tiles = [
    {
      Icon: FaPhone,
      title: "Number of Calls",
      value: Tools.formatNumber(callCount),
      trend: percentageChangeContent,
    },
    { Icon: FaUsers, title: "Number of Agents", value: Tools.formatNumber(agentCount) },
    { Icon: FaBullseye, title: "Total Intents", value: Tools.formatNumber(totalIntents) },
    { Icon: FaFolderOpen, title: "Total Categories", value: Tools.formatNumber(totalCategories) },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
      {tiles.map((tile, index) => (
        <div
          key={index}
          className="bg-indigo-700 text-white p-4 rounded-xl shadow-lg flex items-center justify-between h-24 transition-all duration-300 hover:shadow-xl hover:scale-105"
        >
          <div className="flex flex-col items-center flex-grow">
            <div className="flex items-center">
              <p className="text-4xl font-bold">{tile.value}</p>
              {tile.trend && <span className="ml-2">{tile.trend}</span>}
            </div>
            <h3 className="text-sm font-semibold uppercase tracking-wide mt-1">
              {tile.title}
            </h3>
          </div>
          <tile.Icon className="text-4xl opacity-70 ml-4" />
        </div>
      ))}
    </div>
  );
}

export default MainTiles;
